import { Component, OnInit } from '@angular/core';
import { ServiceTypeEnum, RootMenuEnum, MenuPermissionActionEnum, MenuPermissionConfig } from 'app/models';
import { AppDataService } from 'app/services';
import { FeedbackMenuEnum } from '../broadcast-message/broadcast-message.component';
import { AppComponent } from 'app/app.component';
import { ActivatedRoute } from '@angular/router';

export enum CommsMenuEnum {
    BroadcastMessage = 1,
    BroadcastMessageOperators = 2,
    Feedbacks = 3,
    BroadcastMessageDrivers = 4,
    BroadcastMessageCustomers = 5,
    Inquiries = 6
}

@Component({
    selector: 'comms-root',
    templateUrl: './comms-root.component.html',
    styleUrls: ['./comms-root.component.scss',
        '../../../../../styles/menu-sidebar.scss'
    ],
})
export class CommsRootComponent implements OnInit {

    public serviceTypeId!: ServiceTypeEnum;

    constructor(public appData: AppDataService,
                public app: AppComponent,
                private route: ActivatedRoute) { }

    public menuPermissionConfig = MenuPermissionConfig;
    public menuPermissionActionEnum = MenuPermissionActionEnum;

    public menuPermissionActive!: string;

    public activeRootMenu: RootMenuEnum | null = null;

    public feedbackMenuEnum = FeedbackMenuEnum;
    public menuEnum = CommsMenuEnum;
    public activeMenu: CommsMenuEnum = CommsMenuEnum.BroadcastMessage;

    ngOnInit(): void {
        this.activeRootMenu = this.appData.activeRootMenu;
        this.route.params.subscribe(params => {
            const paramData = params['id'];
            const menuEnum = this.getMenuEnumFromPermission(paramData);
            this.activeMenu = menuEnum;
            this.getFeedbackMenuItem(this.activeMenu);
            this.clickMenu(paramData, this.activeMenu);
        });
    }

    private getMenuEnumFromPermission(permission: string): CommsMenuEnum {
        switch (permission) {
            case MenuPermissionConfig.COMMS_BROADCAST_MESSAGE_OPERATORS:
                return CommsMenuEnum.BroadcastMessageOperators;
            case MenuPermissionConfig.COMMS_BROADCAST_MESSAGE_DRIVERS:
                return CommsMenuEnum.BroadcastMessageDrivers;
            case MenuPermissionConfig.COMMS_BROADCAST_MESSAGE_CUSTOMERS:
                return CommsMenuEnum.BroadcastMessageCustomers;
            case MenuPermissionConfig.COMMS_FEEDBACKS:
                return CommsMenuEnum.Feedbacks;
            default:
                return CommsMenuEnum.BroadcastMessage;
        }
    }

    public clickMenu(menuPermissionActive: string, menu: CommsMenuEnum) {
        this.menuPermissionActive = menuPermissionActive;
        this.activeMenu = menu;
    }

    getFeedbackMenuItem(value: CommsMenuEnum) {
        switch (value) {
            case CommsMenuEnum.BroadcastMessageDrivers: return this.feedbackMenuEnum.BroadcastMessageDrivers;
            case CommsMenuEnum.BroadcastMessageCustomers: return this.feedbackMenuEnum.BroadcastMessageCustomers;
            default: return 0;
        }
    }
}
